module.exports = __webpack_public_path__ + "static/img/gsdz.270c007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gsdz.png
// module id = OHcj
// module chunks = 1